import React from "react";

let Updating = React.createClass({
    render() {
        return (
            <div className="eo-updating-container animate">
                <p className="text heading">Your eero is updating...</p>
                <div className="visual">
                    <div className="bar"></div>
                </div>
            </div>
        );
    }
});

export default Updating;


/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/features/components/Updating.js
 **/